<div class="actions">

  <spb-filter
    [items]="service.items()"
    [(filtered)]="filtered"
  />
  <div style="flex-grow: 1"></div>
  <button matMiniFab
          matTooltip="Starta ny kalkyl"
          [routerLink]="['/', HOME_PATH, GUIDE_PATH]">
    <mat-icon>signpost</mat-icon>
  </button>
</div>

<spb-list [source]="filtered()"/>